/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import type { FetchBaseQueryArgs } from '@reduxjs/toolkit/query';
import { getActiveWorker } from '../db/Worker';

type PrepareHeadersFn = NonNullable<FetchBaseQueryArgs['prepareHeaders']>;

export const setKaryaWorkerIdToken: PrepareHeadersFn = async (headers) => {
  const [activeWorker, error] = await getActiveWorker().unwrapResult().toTuple();

  if (error) {
    return;
  }

  headers.set('karya_worker_id_token', `${activeWorker.id_token}`);

  return headers;
};
